import { ReactComponent as ProgressCompletedIcon } from '../../../../../assets/progress-completed-icon.svg';
import { ReactComponent as ProgressActiveIcon } from '../../../../../assets/progress-active-icon.svg';
import { ReactComponent as ProgressFutureIcon } from '../../../../../assets/progress-future-icon.svg';
import { IStatusHistory } from '../../../../../models/parcelDeliveryMiles';

export type ParcelHistoryProgress = 'completed' | 'active' | 'future';

type Icon = {
  [key in ParcelHistoryProgress]: React.ReactNode;
};

const icons: Icon = {
  completed: <ProgressCompletedIcon />,
  active: <ProgressActiveIcon />,
  future: <ProgressFutureIcon />,
};

export const getIcon = (progress: ParcelHistoryProgress) => icons[progress];

export const getStatusProgress = (
  statusIdex: number,
  currentStatusIndex: number,
  lastIndex: number
): ParcelHistoryProgress => {
  if (statusIdex < lastIndex && statusIdex === currentStatusIndex) {
    return 'active';
  }

  if (statusIdex > currentStatusIndex) {
    return 'future';
  }

  return 'completed';
};

export const isParcelSent = (history: IStatusHistory[] | null) =>
  history?.find(
    (x) => !!x.created_at && (x.status === 'sent' || x.status === 'in_delivery')
  );

export const isParcelReadyForPickup = (history: IStatusHistory[] | null) =>
  !!history?.find((x) => x.status === 'ready_to_pick_up')?.created_at;
